/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassFinishWindow = Prefab.createWindow(
    (mission) => (bundles[`season_pass_${mission.logic.period}`] ? "season_pass_finish_window" : "season_pass_fallback_windows"),
    (mission) => (bundles[`season_pass_${mission.logic.period}`] ? "finish_window_prefab_json" : "fallback_finish_window_prefab_json"),
    {
        theme: (mission) => (bundles[`season_pass_${mission.logic.period}`] ? bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`] : undefined),
        bundles: SeasonPassLogic.listWindowBundles
    }
);

const SeasonPassFinishWindowFallback = Prefab.createWindow(
    "season_pass_fallback_windows",
    "fallback_finish_window_prefab_json"
);
